import React from 'react';
import {connect} from 'react-redux';

import {toggleGroup as toggleGroupAction,
        expandGroup as toggleExpandGroup} from 'actions/creators/ToggleGroup';

import Body from './Body.jsx';
import MainLine from './MainLine.jsx';
import MatchScores from './matchStats/MatchScores.jsx';

class Group extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        group: React.PropTypes.object,
        hasChildGroups: React.PropTypes.bool.isRequired,
        isParentExpanded: React.PropTypes.bool,
        hasParent: React.PropTypes.bool,
        matchId: React.PropTypes.number,
        gridLocalization: React.PropTypes.object.isRequired,
        toggleGroupAction: React.PropTypes.func.isRequired,
        toggleExpandGroup: React.PropTypes.func.isRequired,
        nestingLevel: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this._onExpandBodyClick = this._onExpandBodyClick.bind(this);
        this._onExpandGroupClick = this._onExpandGroupClick.bind(this);
    }

    _onExpandBodyClick(e) {
        e.preventDefault();
        this.props.toggleGroupAction(this.props.group.get('id'), this.props.section);
    }

    _onExpandGroupClick(e) {
        e.preventDefault();
        this.props.toggleExpandGroup(this.props.group.get('id'), this.props.section);
    }

    render() {
        const props = this.props;
        const {
            section,
            group,
            matchId,
            gridLocalization,
            nestingLevel,
            hasChildGroups,
            isParentExpanded,
            hasParent} = props;

        if (group === undefined || matchId === undefined) {
            return false;
        }

        const groupId = group.get('id');
        const realSportId = group.get('realSportId');
        const groupType = group.get('type');
        const groupName = gridLocalization.getGroupName(realSportId, groupType);

        const groupIsClosed = group.get('isClosed');
        const groupIsExpanded = group.get('isExpanded');

        let headerCls = 'event-body-sections';
        if (hasParent && !isParentExpanded) {
            headerCls += " closed";
        }

        let groupClass = 'event-section-name';
        // const hasBody = group.get('outcomes').size > group.get('headers').size;
        const hasBody = group.get('hasBody');
        if (hasBody) {
            groupClass += groupIsClosed ?
                ' event-section-name--closed' :
                ' event-section-name--expanded';
        }

        const scoresProps = {
            section,
            matchId,
            groupId,
            gridLocalization
        };

        const expandClass = groupIsExpanded ? "expand" : "collapse";

        let groupHeader;
        if (hasBody) {
            groupHeader = (
            <div className="group-controls">
                {hasChildGroups &&
                <a href="#" className={expandClass} onClick={this._onExpandGroupClick}>
                    <span>{'\u00A0'}</span>
                </a>}
                <a href="#"
                   className={groupClass}
                   style={{paddingLeft: '15px'}}
                   onClick={this._onExpandBodyClick}>
                    {groupName}
                </a>
            </div>);
        } else {
            groupHeader = (
            <div className="group-controls">
                {hasChildGroups &&
                <a href="#" className={expandClass} onClick={this._onExpandGroupClick}>
                    <span>{'\u00A0'}</span>
                </a>}
                <span className={groupClass} style={{paddingLeft: '15px'}}>
                    {groupName}
                </span>
            </div>);
        }

        const bodyProps = {
            ...props,
            nestingLevel
        };

        const cellContentClass = `cell-content level-${nestingLevel}`;

        return (
            <div className={headerCls}>
                <div className="table inner">
                    <div className="row inner">
                        <span className="cell main">
                            <span className={cellContentClass}>
                                {groupHeader}
                                {section === 'live' && <span className="cell-main tools ">
                                    <MatchScores {...scoresProps}/>
                                </span>}
                            </span>
                        </span>

                        <MainLine id={groupId} section={section} gridLocalization={gridLocalization}/>
                    </div>
                </div>

                {!groupIsClosed && <Body key={groupId} id={groupId} {...bodyProps} />}
            </div>
        );
    }
}

function select(state, props) {
    const {section, id, matchId, gridLocalization, hasChildGroups} = props;
    const group = state.application.getIn([section, 'groups', id]);

    return {
        section,
        matchId,
        group,
        gridLocalization,
        hasChildGroups
    };
}

export default connect(select, {toggleGroupAction, toggleExpandGroup})(Group);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/Group.jsx